import Tabs, { SimpleTabs, Tab, TabContent, TabHeader } from './Tabs';

export default Tabs;
export { SimpleTabs, Tab, TabContent, TabHeader };
